import React from "react";
// import loading from "../../assets/img/icons/loader_01.gif";
import loading from "../../assets/video/virsat-page-opt3.gif";

const Loading = ({message="Sending your message..."}) => {
  return (
    <div className='modal-saving'>
      <div className='wrapper'>
        <img src={loading} alt='Loading' />
        <div className='main-subtitle center light large'>
          {message}
        </div>
      </div>
    </div>
  );
};

export default Loading;
